const httpCode: any = {};
httpCode[100] = 'Continue';
httpCode[101] = 'Switching Protocols';
httpCode[102] = 'Processing';
httpCode[200] = 'OK';
httpCode[201] = 'Created';
httpCode[202] = 'Accepted';
httpCode[203] = 'Non Authoritative Information';
httpCode[204] = 'No Content';
httpCode[205] = 'Reset Content';
httpCode[206] = 'Partial Content';
httpCode[207] = 'Multi Status';
httpCode[300] = 'Multiplee Choices';
httpCode[301] = 'Moved Permanently';
httpCode[302] = 'Moved Temporarily';
httpCode[303] = 'See Other';
httpCode[304] = 'Not Modified';
httpCode[305] = 'Use Proxy';
httpCode[306] = 'Partial Content';
httpCode[307] = 'Temporary Redirect';
httpCode[308] = 'Permanent Redirect';
httpCode[400] = 'Bad Request';
httpCode[401] = 'Unauthorized';
httpCode[402] = 'Payment Required';
httpCode[403] = 'Forbidden';
httpCode[404] = 'Not Found';
httpCode[405] = 'Method Not Allowed';
httpCode[406] = 'Not Acceptable';
httpCode[407] = 'Proxy Authentication Required';
httpCode[408] = 'Request Timeout';
httpCode[409] = 'Conflict';
httpCode[410] = 'Gone';
httpCode[411] = 'Length Required';
httpCode[412] = 'Precondition Failed';
httpCode[413] = 'Request Entity Too Large';
httpCode[414] = 'Request-URI Too Long';
httpCode[415] = 'Unsupported Media Type';
httpCode[416] = 'Requested Range Not Satisfiable';
httpCode[417] = 'Expectation Failed';
httpCode[418] = "I'm a teapot";
httpCode[419] = 'Insufficient Space on Resource';
httpCode[420] = 'Method Failure';
httpCode[422] = 'Unprocessable Entity';
httpCode[423] = 'Locked';
httpCode[424] = 'Failed Dependency';
httpCode[428] = 'Precondition Required';
httpCode[429] = 'Too Many Requests';
httpCode[431] = 'Request Header Fields Too Large';
httpCode[451] = 'Unavailable For Legal Reasons';
httpCode[500] = 'Internal Server Error';
httpCode[501] = 'Not Implemented';
httpCode[502] = 'Bad Gateway';
httpCode[503] = 'Service Unavailable';
httpCode[504] = 'Gateway Timeout';
httpCode[505] = 'HTTP Version Not Supported';
httpCode[507] = 'Insufficient Storage';
httpCode[511] = 'Network Authentication Required';

export const convertHttpStatusTolabel = (status: any) => {
  return httpCode[status];
};
